import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';
import { makeStyles } from '@material-ui/core/styles';

const darkTheme = {
  root: {
    '& $closeButton': {
      '&.MuiIconButton-root': {
        color: TextColors.light,
      },
    },

    '& $rtc': {
      '& h5': {
        color: hexToRGBA(TextColors.light, TextOpacities.light2),
      },
    },
  },
  bannerContent: {
    '& $closeButton': {
      '&.MuiIconButton-root': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $closeButton': {
      '&.MuiIconButton-root': {
        color: TextColors.dark,
      },
    },

    '& $rtc': {
      '& h5': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
      },
    },
  },
  bannerContent: {
    '& $closeButton': {
      '&.MuiIconButton-root': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      '& .content-container__content': {
        maxHeight: '100vh',
        overflowY: 'auto',
      },
    },
    paper: {
      '&.MuiPaper-root': {
        backgroundColor: 'transparent',
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: muiTheme.zIndex.appBar,
        maxHeight: '100%',
      },
    },
    modal: {
      width: '100%',
      height: 'initial',
      margin: 'auto',

      [muiTheme.breakpoints.up('xs')]: {
        width: '90%',
      },
      [muiTheme.breakpoints.up('md')]: {
        width: '80%',
      },
    },
    bannerContent: {
      '&.dark-theme': darkTheme.bannerContent,
      '&.light-theme': lightTheme.bannerContent,
      position: 'relative',
      padding: '25px 74px',
      borderRadius: '6px',
    },
    footerContent: {
      position: 'relative',
      padding: '53px 0 44px 0',
    },
    closeButton: {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: muiTheme.zIndex.appBar,
    },
    columnContent: {
      '& .columns': {
        '& .column': {
          '& > * > * + *': {
            marginTop: muiTheme.spacing(3),
          },
        },
      },
    },
    columnContentPictureBanner: {
      '& .columns': {
        '& .column': {
          '& picture': {
            maxWidth: '148px',

            [muiTheme.breakpoints.up('md')]: {
              marginBottom: '-22px',
            },
          },
        },
      },
    },
    columnContentPictureFooter: {
      '& .columns': {
        '& .column': {
          '& picture': {
            maxWidth: '267px',

            [muiTheme.breakpoints.up('md')]: {
              marginBottom: '-44px',
            },
          },
        },
      },
    },
    columnCenterAlign: {
      '& .columns': {
        alignItems: 'center',
        alignContent: 'center',
      },
    },
    multiLink: {
      margin: muiTheme.spacing(-1.5),
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',

      '& > .buttonWrapper': {
        padding: muiTheme.spacing(1.5),

        '& > *': {
          width: '100%',
        },

        [muiTheme.breakpoints.down('xs')]: {
          width: '100%',
        },
      },
    },
    link: {
      display: 'inline-block',
      margin: 0,
      whiteSpace: 'nowrap',

      [muiTheme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    rtc: {},
  }),
  { name: 'GenStickyPopup' },
);

export default useStyles;
